// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Upload } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconUpload(props: any) {
    return <IconBase icon={Upload} {...props} />
  }

  export default IconUpload
  